export interface AiContentVerifyFilePreviewProps {
  file: File;
}

export enum FilePreviewKind {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
}

export const IMAGE_MIME_PREFIX = 'image/';
export const VIDEO_MIME_PREFIX = 'video/';
export const AUDIO_MIME_PREFIX = 'audio/';
export const PDF_MIME_TYPE = 'application/pdf';
export const PDF_ICON = 'icon-file-pdf';
export const HTML_ICON = 'icon-html';
